export default __webpack_public_path__ + "static/media/carousel-right-arrow-rental.52c18a2c.svg";